import classNames from 'classnames';
import { Children, ReactNode } from 'react';
import { IconType } from 'react-icons';
import './IconSeparatedColumns.scss';

interface IconSeparatedColumnProps {
    Icon: IconType;
    children: ReactNode;
    className?: string;
    flip?: boolean;
}

export function IconSeparatedColumns({
    className,
    flip,
    children,
    Icon,
}: IconSeparatedColumnProps) {
    const [first, second] = Children.toArray(children);

    return (
        <div
            data-testid="IconSeparatedColumns"
            className={classNames('IconSeparatedColumns', className, {
                'IconSeparatedColumns--flip': flip,
            })}
        >
            <div className="IconSeparatedColumns__column">{first}</div>
            <Icon className="IconSeparatedColumns__icon" />
            <div className="IconSeparatedColumns__column">{second}</div>
        </div>
    );
}
